<div class="estimation-table">
  <nz-tabset [nzSelectedIndex]="currentTab">
    @for (tab of estimationTabsList; track $index; let tabIndex = $index) {
    <nz-tab nzTitle={{tab}} (nzClick)="onChangeEstimationTab(tabIndex)">
      <nz-table #sortTable [nzData]="estimationTableData" nzTableLayout="fixed" [nzNoResult]="emptyEstimations"
        [nzScroll]="{ x: '950px' }" nzShowPagination="true" [nzLoading]="loading" [nzPageSize]="pageSize" nzFrontPagination="true"
        [nzTotal]="totalEstimations">
        <thead>
          <tr>
            @for (column of estimationColumnsList; track column.name; let i = $index) {
              <th [nzWidth]="column.width" [nzAlign]="column.align === 'center' ? 'center'
                                        : column.align === 'right' ? 'right'
                                        : column.align === 'left' ? 'left'
                                        : null" style="white-space: pre-line;">
                <div class="column-header">
                  {{ column.title }}
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (data of sortTable.data; track data.estimationId; let rowIndex = $index) {
          <tr class="selectable-row" (click)="onGoToEstimationDetails(data)">
            <td>
              <div class="info">
                <span class="key">{{data.project.projectName}}</span>
              </div>
            </td>
            <td class="provider-column">{{ data.supplier.name || 'No disponible' }}</td>
            <td class="folio-column">
              {{ data.estimationFolio | number : '3.0-0': 'en-US'}}
              @if (!currentRowElements[rowIndex]!.isFolioTooltipVisible) {
                <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                  nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                  (click)="onCopyToClipboard(data.estimationKey, rowIndex, $event)"></span>
              }
              @if (currentRowElements[rowIndex]!.isFolioTooltipVisible && currentTab === tabIndex) {
                <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                  nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                  [nzTooltipVisible]="currentRowElements[rowIndex]!.isFolioTooltipVisible"
                  ></span>
              }
            </td>
            <td>
              <div class="id-column-container">
                <div class="info">
                  <span class="description">{{ data.estimationDescription }}</span>
                </div>
                @if (data.estimationIsHighlighted) {
                <button class="action-icon-buttons" nz-button nzType="text"
                  (click)="onHighlightEstimation(data, false, rowIndex, $event)">
                  <span nz-icon nzType="star" nzTheme="outline"></span>
                </button>
                }
                @if (data.estimationNotes && data.estimationNotes !== '') {
                <button class="action-icon-buttons" nz-button nzType="text"
                  (click)="onSelectNote(data.estimationId)">
                  <img class="icon action-icon-buttons" src="assets/TwoTone.svg">
                </button>
                }
              </div>
            </td>
            <td nzAlign="center">
              {{ (data.estimationApplicationDate | date: 'dd-MM-yyyy') || 'No disponible' }}
            </td>
            <td>
              <div class="requester-container">
                <div class="profile-image">
                  <img
                    src="{{data.userWhoRequests.img !== '' ? data.userWhoRequests.img : '../../../../assets/UserOutlined.svg'}}">
                </div>
                <div class="requester-info">
                  <span class="requester-name">{{ data.userWhoRequests.name || 'No disponible'}}</span>
                  <span>{{ data.userWhoRequests.role || 'No disponible'}}</span>
                </div>
              </div>
            </td>
            <td nzAlign="right">${{data.totalCost | number : '1.2-2': 'en-US'}}</td>
            <td nzAlign="center">
              <div class="priority-tag-container">
                <app-priority-tag [backgroundColor]="data.estimationPriority.backgroundColor"
                  [borderColor]="data.estimationPriority.borderColor" [label]="data.estimationPriority.label"
                  [textColor]="data.estimationPriority.textColor"></app-priority-tag>
              </div>
            </td>
            <td nzAlign="center">
              <app-status-tag [backgroundColor]="data.estimationProgress.backgroundColor"
                [borderColor]="data.estimationProgress.borderColor" [icon]="data.estimationProgress.icon"
                [label]="data.estimationProgress.label" [textColor]="data.estimationProgress.textColor"></app-status-tag>
            </td>
          </tr>
          @if (openedNotes.has(data.estimationId)) {
            <tr class="note-row">
              <td class="note-info">
                <span>{{data.estimationNotes}}</span>
                <button nz-button nzType="text" (click)="onCloseNote(data.estimationId)">
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                </button>
              </td>
            </tr>
          }
          }
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>Total {{ totalEstimations }} items</ng-template>
    </nz-tab>
    }
  </nz-tabset>
  <ng-template #emptyEstimations>
    <nz-empty [nzNotFoundContent]="null" [nzNotFoundImage]="'assets/Empty.svg'">
    </nz-empty>
    <span>
      Aún no tienes estimaciones
    </span>
  </ng-template>
</div>

